import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { App } from "./App"
import { captureToken } from "./lib/session"
import { aplicarTema } from "./parceiros/aplicarTema"
import { ParceiroProvider } from "./parceiros/contexto"
import { resolverParceiro } from "./parceiros/registro"
import "./index.css"

// Antes de qualquer render: a primeira busca não pode sair sem o Authorization. Em efeito, a
// ordem entre o carimbo do token e o disparo da query fica à mercê do React.
const token = captureToken()

// E o parceiro logo depois, a partir do mesmo token: a página já nasce com a marca certa.
const parceiro = resolverParceiro({ hostname: window.location.hostname, token })
aplicarTema(parceiro)

const rootElement = document.getElementById("root")
if (!rootElement) throw new Error("Elemento #root não encontrado")

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // O RH abre uma vez por mês: não há o que revalidar ao voltar para a aba, e um retry
            // infinito só esconde do usuário que a chamada falhou.
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 60_000,
        },
    },
})

createRoot(rootElement).render(
    <StrictMode>
        <ParceiroProvider parceiro={parceiro}>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </ParceiroProvider>
    </StrictMode>,
)
